import getLegacyCampusURL from "./getLegacyCampusURL";

/**
 * Returns a URL with path for the legacy site at a given campus.
 *
 * Example:
 * 		getLegacySitePath("/about") => "https://xx.aopsacademy.club/about"
 * 		getLegacySitePath("/pizza", "san-diego") => "https://san-diego.xx.aopsacademy.club/pizza"
 */
const getLegacySitePath = (path: string, campusId?: string | null) => {
	let campusUrl = getLegacyCampusURL(campusId);
	if (campusUrl.endsWith("/")) {
		campusUrl = campusUrl.slice(0, -1);
	}
	return `${campusUrl}${path.startsWith("/") ? "" : "/"}${path}`;
};

export default getLegacySitePath;
